<template>
  <section
    :data-active="active"
    @dragenter.prevent="setActive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
    @drop.prevent="onDrop"
    class="dataset-dropfile"
    :class="{
      'dataset-dropfile--active': active,
    }"
  >
    <div
      class="dataset-dropfile__inner"
      :class="{
        'dataset-dropfile__inner--error': hasError,
      }"
    >
      <div class="dataset-dropfile__inner-left">
        <IconXls :shadow="true" />
      </div>
      <div class="dataset-dropfile__inner-right">
        <template v-if="selectedFile">
          <h4>{{ selectedFile.name }}</h4>
          <button type="button" @click="$emit('clear-file')">Clear</button>
        </template>
        <template v-else>
          <p class="dataset-dropfile__top-text">
            <BaseInputFile
              :accept-types="[
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
              ]"
              @file-changed="handleFileUpload"
            >
              Choose a file
            </BaseInputFile>
            or drag and drop it here.
          </p>
          <p class="dataset-dropfile__bottom-text">
            Need the Dataset Template first?
            <a
              href="/storage/Documents/ITR_Company_Data_Template.xlsx"
              class="dataset-dropfile__button-text"
              download
            >
              Download it here
            </a>
            .
          </p>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
  import IconXls from '../icon/IconXls.vue';
  import BaseInputFile from '../base/BaseInputFile.vue';

  export default {
    name: 'DatasetDropfile',
    components: { IconXls, BaseInputFile },
    props: {
      selectedFile: {
        type: File,
        required: false,
        default: null,
      },
      isPortalData: {
        type: [Boolean, Number],
        defualt: true,
      },
      hasError: Boolean,
    },
    data: () => ({
      active: false,
    }),
    methods: {
      setActive() {
        this.active = true;
      },
      setInactive(event) {
        if (event && event.target.className.includes('dataset-dropfile'))
          return;
        this.active = false;
      },
      onDrop(event) {
        if (!event?.dataTransfer?.files) return;
        this.setInactive();
        this.$emit('file-uploaded', event.dataTransfer.files[0]);
      },
      handleFileUpload(event) {
        let file = null;

        if (event?.target?.files[0]) {
          file = event.target.files[0];
        } else if (event?.dataTransfer?.files[0]) {
          file = event.dataTransfer.files[0];
        }

        this.$emit('file-uploaded', file);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dataset-dropfile {
    position: relative;
    padding: 15px;
    background-color: #d2d2d3;

    &::before {
      display: none;
      visibility: hidden;
      opacity: 0;
      z-index: -1;

      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      width: 100%;
      height: 100%;

      transition: background-color 300ms ease-in-out;
      background-color: rgba(0, 0, 0, 0.2);
    }

    &--active {
      &::before {
        display: block;
        visibility: visible;
        opacity: 1;
        z-index: 10;

        transition: background-color 300ms ease-in-out;
        background-color: rgba(0, 0, 0, 0.4);
      }
    }

    &__inner {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 3px dashed #3075a4;
      padding: 47px 60px;
      z-index: 1;

      height: 100%;

      &--error {
        border: 3px dashed #eb5757;
      }
    }
    &__inner-left {
      padding: 0 10px;
    }
    &__inner-right {
      display: flex;
      flex-direction: column;
      flex: 1 auto;
      text-align: center;
    }
    &__top-text {
      flex: 1 auto;
      color: #343536;
      font-size: 18px;
    }
    &__bottom-text {
      font-size: 16px;
      color: #09a684;
    }
    &__button-text {
      padding: 0;
      text-decoration: underline;
      font-weight: 700;
      background-color: transparent;
      color: inherit;
      cursor: pointer;
    }
  }
</style>
